<template>
  <v-row justify="center">
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="mt-13"
          color="light-blue darken-4"
          dark
          small
          right
          top
          fixed
          fab
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon medium>
            mdi-help
          </v-icon>
        </v-btn>
      </template>
      <span>Ayuda</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog"
      max-width="640"
    >
      <v-card>
        <!-- <v-card-title class="headline text-left">
          Tutorial
        </v-card-title> -->

        <v-card-text>
          <tutorials :tutorial="tutorial" />
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="close"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import Tutorials from '@/views/dashboard/tutorials/DialogTutorial'

  export default {
    components: {
      Tutorials,
    },
    props: {
      tutorial: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        dialog: false,
      }
    },
    methods: {
      close () {
        this.dialog = false
      },
    },
  }
</script>
